export const minDateForCalendar = (eventStartDate) => {
  if (!eventStartDate) {
    return new Date();
  }

  return new Date(eventStartDate) > new Date() ? new Date(eventStartDate) : new Date();
};
